import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="movie-notification"
export default class extends Controller {
  static targets = ["menu"];

  connect() {
    console.log("MovieNotification controller connected", this.element);
    console.log("Menu target found:", this.hasMenuTarget);

    // Add event listener for clicks outside the dropdown
    document.addEventListener("click", this.handleOutsideClick.bind(this));
  }

  disconnect() {
    // Clean up event listener when controller disconnects
    document.removeEventListener("click", this.handleOutsideClick.bind(this));
  }

  toggle(event) {
    console.log("Toggle called", event);
    event.preventDefault();
    event.stopPropagation();

    if (this.hasMenuTarget) {
      console.log("Toggling menu", this.menuTarget);
      this.menuTarget.classList.toggle("hidden");

      // Adjust position when showing
      if (!this.menuTarget.classList.contains("hidden")) {
        this.positionMenu();
      }
    } else {
      console.error("Menu target not found!");
    }
  }

  handleOutsideClick(event) {
    // Close if click is outside this dropdown
    if (
      this.hasMenuTarget &&
      !this.element.contains(event.target) &&
      !this.menuTarget.classList.contains("hidden")
    ) {
      this.menuTarget.classList.add("hidden");
    }
  }

  // Handle form submission when selection changes
  submitForm(event) {
    console.log("Submit form called", event);
    if (event.target.form) {
      event.target.form.requestSubmit();
    }
  }

  // Position menu properly relative to the movie card
  positionMenu() {
    if (!this.hasMenuTarget) return;

    const menu = this.menuTarget;
    const parentCard = this.findParentCard();

    if (parentCard) {
      const parentWidth = parentCard.offsetWidth;
      menu.style.width = `${parentWidth}px`;

      // Make sure menu is visible on top
      menu.style.zIndex = "50";
    }
  }

  findParentCard() {
    let element = this.element;

    while (element && !element.id.includes("movie_card_container")) {
      element = element.parentElement;
    }

    return element;
  }
}
